module.exports = __webpack_public_path__ + "media/images/payments/paymill-835a10be123b730a314ddb29f0b2cbad.svg";